<template>
    <div class="premium-gallery-entry">
        <div class="premium-gallery-entry--thumbnail" @click="onEntryClick">
            <div v-if="!gallery.purchased" class="premium-gallery-entry--blur"></div>
            <picture v-if="gallery.defaultPhoto">
                <source :srcset="gallery.defaultPhoto.urls.jpg" type="image/jpg">
                <img :alt="gallery.title || 'Gallery'"
                     :src="gallery.defaultPhoto.urls.jpg">
            </picture>
            <img v-else-if="gallery.videoThumbnail"
                 :alt="gallery.title || 'Gallery'"
                 :src="gallery.videoThumbnail">
        </div>

        <div class="premium-gallery-entry--info">
            <p v-if="gallery.title" class="premium-gallery-entry--title">{{ gallery.title }}</p>
            <div class="premium-gallery-entry--counts">
                <div>
                    {{ translate.home.premiumPhotos }} <span class="text-pink font-bold">{{ gallery.photoQuantity }}</span>
                </div>
                <div v-if="isVideoUploadEnabled">
                    {{ translate.home.premiumVideos }} <span class="text-pink font-bold">{{ gallery.videoQuantity }}</span>
                </div>
            </div>
        </div>

        <button v-if="gallery.purchased"
                class="btn btn-rebrand-primary btn-rebrand-xs w-full"
                @click.prevent="$emit('viewGallery', gallery)">
            {{ translate.home.viewGallery }}
        </button>
        <button v-else
                class="btn btn-rebrand-primary btn-rebrand-xs w-full"
                @click.prevent="$emit('purchaseGallery', gallery)">
            {{ translate.home.purchase }}
        </button>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    props: {
        gallery: {
            type: Object,
            required: true
        },
        user: {
            type: Object,
            default: null
        }
    },
    computed: {
        ...mapState(['translate', 'regionData']),
        isVideoUploadEnabled() {
            return !_.has(this.regionData, 'sectionsToHide.videoUpload');
        },
    },
    methods: {
        onEntryClick() {
            if (this.gallery.purchased) {
                this.$emit('viewGallery', this.gallery);
            } else {
                this.$emit('purchaseGallery', this.gallery);
            }
        }
    }
}
</script>
